import { Button } from '@daily/shared/components/Button';
import { CardContent } from '@daily/shared/components/Card';
import { Text } from '@daily/shared/components/Text';
import { t } from 'i18next';
import React, { memo } from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClickLeaveCall(): void;
  onClickLeaveRoom(): void;
}

export const BreakoutLeaveMenuContent: React.FC<
  React.PropsWithChildren<Props>
> = memo(({ onClickLeaveCall, onClickLeaveRoom, ...props }) => {
  return (
    <div className="breakout-leave-menu-content" {...props}>
      <CardContent>
        <Button
          id="breakouts-leave-room"
          className="breakout-leave-room-btn"
          fullWidth
          onClick={onClickLeaveRoom}
          variant="primary"
        >
          <Text color="inherit" variant="strong">
            {t('breakouts.leaveToMain')}
          </Text>
        </Button>
        <Button
          id="breakouts-leave-call"
          className="breakout-leave-call-btn"
          fullWidth
          onClick={onClickLeaveCall}
          variant="secondary"
        >
          <Text variant="strong">{t('breakouts.leaveEntirely')}</Text>
        </Button>
      </CardContent>
      <style jsx>{`
        .breakout-leave-menu-content :global(.card-content) {
          display: grid;
          gap: 10px;
          height: auto;
          min-width: 225px;
          padding: 15px;
        }
      `}</style>
    </div>
  );
});
BreakoutLeaveMenuContent.displayName = 'BreakoutLeaveMenuContent';
